import api from "../../services/api";
import { bus } from "../../main";

export default {
	props: {
		field: String,
		dataItem: Object,
		format: String,
		className: String,
		columnIndex: Number,
		columnsCount: Number,
		rowType: String,
		level: Number,
		expanded: Boolean,
		editor: String,

		lat: null,
		lng: null
	},

	data: function() {
		return {
			address: "",

			number_plate: "",
			previousLat: null,
			previousLng: null,

			polling: null,
			intervalPollingSeconds: 600

			//isEnabled: true
		};
	},

	watch: {
		dataItem: {
			handler() {
				if (this.dataItem) {
					this.address = this.dataItem.address;
					if (this.dataItem.current_position) {
						this.lat = this.dataItem.current_position.lat;
						this.lng = this.dataItem.current_position.lon;
					}
				}
			},
			deep: true
		}
	},

	created() {
		var self = this;

		self.number_plate = self.dataItem.number_plate;
		self.previousLat = self.lat;
		self.previousLng = self.lng;
		self.address = self.dataItem.address;

		self.getData();
	},

	updated() {
		//do not use, this update information always
		// var self = this;
		// self.number_plate = self.dataItem.number_plate;
		// self.previousLat = self.lat;
		// self.previousLng = self.lng;
	},

	beforeDestroy() {
		this.destroyPollingInterval();
	},

	methods: {
		clickHandler() {
			this.$emit("reverse-geocoding-click", this);
		},
		pollData() {
			this.polling = setInterval(() => {
				this.getData();
			}, this.intervalPollingSeconds * 1000);
		},

		getData: function() {
			if (this.lat && this.lng) {
				var self = this;

				if (this.previousLat === null || this.previousLat != this.lat || this.previousLng === null || this.previousLng != this.lng) {
					var params = {
						latitude: this.lat,
						longitude: this.lng
					};

					api.getReverseGeocoding(params).then(res => {
						if (res && res.length > 0) {
							var newAddress = self._.find(res, function(item) {
								return (
									self._.find(item.types, function(x) {
										return x === "streetAddress";
									}) != null
								);
							});

							if (!newAddress) {
								newAddress = res[0];
							}

							self.previousLat = self.lat;
							self.previousLng = self.lng;
							var address = "";
							if (newAddress && newAddress.formattedAddress) {
								address = newAddress.formattedAddress;
							}
							self.address = address;

							self.previousLat = self.lat;
							self.previousLng = self.lng;
							self.$emit("update-geocoding-address", {
								id: self.dataItem.id,
								address: address
							});
						}
					});
					// } else {
					// self.address = "DISABLED - VIA NAZIONALE, 9, 33010 TAVAGNACCO UD, ITALIA";
					// 	self.previousLat = self.lat;
					// 	self.previousLng = self.lng;
					// }
				}
			}
		},

		refreshData() {
			this.getData();
			bus.$emit("updated-data");
		},

		destroyPollingInterval() {
			clearInterval(this.polling);
		}
	},

	computed: {
		isChangedFromPreviousCoord() {
			if ((this.previousLat !== null && this.previousLat != this.lat) || (this.previousLng !== null && this.previousLng != this.lng)) return true;

			return false;
		}
	}
};
